import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cd2ad08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"80%"},
  src: "/static/img/ilustracoes/nenhuma-novidade.svg"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"100%","text-align":"center"} }, "Nenhuma notícia ainda.", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ss-texto" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_carousel = _resolveComponent("a-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.noticias.length === 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _hoisted_3
        ], 64))
      : (_openBlock(), _createBlock(_component_a_carousel, {
          key: 1,
          "dot-position": "top",
          autoplay: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.noticias, (noticia) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "ss-card",
                key: noticia.codigo
              }, [
                _createElementVNode("img", {
                  class: "ss-imagem",
                  src: noticia.imagem
                }, null, 8, _hoisted_4),
                _createElementVNode("p", _hoisted_5, [
                  _createTextVNode(_toDisplayString(noticia.titulo) + " ", 1),
                  _createElementVNode("a", {
                    href: noticia.urlNoticia
                  }, "Ler mais...", 8, _hoisted_6)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }))
  ]))
}